
export default {
  getAuthHeaders () {
    let token = localStorage.getItem('key')
    // si on a pas de token, on ne fait rien, en revanche si on a un token, on ajoute le header d'auth
    if (token !== null && token !== 'undefined') {
      return { 'Authorization': 'Token ' + token }
    }
    return {}
  },
  getUploadHeaders () {
    return { 'Accept': 'application/json', 'Content-Type': 'image/png' }
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/headers.js